import logo from 'Assets/img/logomark.svg';

const LoadingSite = () => {
  return <img className="loader" src={logo} alt="Nui" />;
};

export default LoadingSite;
